<template>
  <div class="create-course-view">
    <CourseBuilder />
  </div>
</template>

<script>
import CourseBuilder from '@/components/CourseBuilder.vue'

export default {
  name: 'CreateCourse',
  components: {
    CourseBuilder
  }
}
</script>

<style scoped>
.create-course-view {
  padding: 1rem;
}
</style> 